import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import {verificaCache} from '../../../verificaCache';
import axios from 'axios';


import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';



class ListaPropostas extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      page: '',
      titlePage: '',
      apiPage: null,
      data: [],
      isLoading: true,
      isError: false,
      showTable: false,
      showColBroker: false,
      showColSalesman: false,
      showColStage: false,
      disabledInput: true,
      disabledInputValuePlan: true,

      // Variáveis de controle da paginação server-side
      currentPage: 0,
      itemsPerPage: 10,
      totalItems: 0,

      // Variáveis de busca
      searchTerm: '',
      searchField: 'firstName',
      isSearching: false,
      isPaginationLoading: false,
      loadingTable: null,
      isDefaultUser: false,
      
      showDateActive: false,
      showColNossoNumero: true,
    };

    this._isMounted = false;
    this.searchTimeout = null;

    this.errorField = {
      
    };

    this.errorFormat = {
      
    };

    this.styles = {
      theadTr:{
        textTransform: "uppercase",
      },
      inputSearch: {
        marginLeft: 8,
        flex: 1,
      },
      theadTh:{
        height: 35,
      },
      tdDate: {
        color: 'rgb(117, 117, 117)',
        margin: 0,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 500,
        lineHeight: '5px',
        letterSpacing: 0,
        textTransform: 'uppercase',
        padding: 0,
        height: 35,
        fontSize: 8.5,
      }
    }

  }


  componentDidMount() {
    this._isMounted = true;
    verificaCache(function (vc) {
      if (vc.erro === false) {
        let userType = localStorage.getItem('planos_y');
        let state = this.state;

        // Define se é um usuário admin
        state.isDefaultUser = userType !== 'SALESMAN' && userType !== 'BROKER';

        // Verifica se exibe ou não a coluna 'Corretora'
        // A lógica final será definida na resposta da API baseada no brokerDefault
        if (state.isDefaultUser)
          state.showColBroker = true;
        else
          state.showColBroker = false;

        // Verifica se exibe ou não a coluna 'Vendedor'
        if (userType === 'SALESMAN') {
          state.showColSalesman = false;
          // Permite edição de campos do resumo da proposta
          state.disabledInput = false;
          state.disabledInputValuePlan = true;
          // Para vendedores, oculta colunas Nosso Número, NSU e Cód. Autorização em todas as páginas
          state.showColNossoNumero = false;
        }
        else if (userType === 'BROKER') {
          // Para brokers, oculta colunas Nosso Número, NSU e Cód. Autorização em todas as páginas (igual vendedor)
          state.showColNossoNumero = false;
          state.showColSalesman = true;
        }
        else
          state.showColSalesman = true;

        // Verifica exibição de primeiro pagamento
        if (userType === 'REGISTER' || userType === 'AFTER SALES') {
          state.showFirstPayment = true;
          // Permite edição de campos do resumo da proposta
          state.disabledInput = false;
          state.disabledInputValuePlan = false;
          // Para cadastro e pós-venda, oculta colunas Nosso Número, NSU e Cód. Autorização
          state.showColNossoNumero = false;
        }

        this.setState(state);

      
        this.getFilterName();
        this.getData(true);
      }
      else
        this.setError(vc.mensagem);
    }.bind(this));
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  getFilterName() {
    // pega o filtro para saber q nome exibir no titulo
    let state = this.state;
    let page = this.props.history.location.pathname;

    page = page.split('/');
    page = page[page.length - 1];

    state.page = page;

    if (page === "geralpf") {
      state.titlePage = "TODAS AS PROPOSTAS - PF";
      state.apiPage = 'all';
    }
    else if (page === "pendentespf") {
      state.titlePage = configBase.statusPendente+" - PF";
      state.apiPage = 'awaitingSolution';
    }
    else if (page === "emaverbacaopf") {
      state.titlePage = configBase.statusEmAverbacao+" - PF";
      state.apiPage = 'inAverbation';
    }
    else if (page === "funcempresa") {
      state.titlePage = configBase.statusFuncEmpresa;
      state.apiPage = 'funcEmpresas';
    }
    else if (page === "indeferidaspf") {
      state.titlePage = configBase.statusIndeferida+" - PF";
      state.apiPage = 'pending';
    }
    else if (page === "emanalisepf") {
      state.titlePage = configBase.statusEmAnalise+" - PF";
      state.apiPage = 'waitingConfirmation';
    }
    else if (page === "novaspf") {
      state.titlePage = configBase.statusNova+" - PF";
      state.apiPage = 'clientConfirmation';
      // Verifica exibição da coluna Estágio
      state.showColStage = true;
    }
    else if (page === "implantadaspf") {
      state.titlePage = configBase.statusImplementadas+" - PF";
      state.apiPage = 'implantedContracts';
      state.showDateActive = true;
    }
    else if (page === "preimplantadaspf") {
        state.titlePage = configBase.statusPreImplantadas+" - PF";
        state.apiPage = 'preImplantedContracts';
        state.showDateActive = true;
      }
    else if (page === "validadaspf") {
      state.titlePage = configBase.statusValidadas+" - PF";
      state.apiPage = 'validatedContracts';
    }
    else if (page === "canceladaspf") {
      state.titlePage = configBase.statusCanceladas+" - PF";
      state.apiPage = 'canceledContracts';
    }
    else 
      state.titlePage = "PÁGINA INCORRETA";
      

    this.setState(state);
  }

  getData(table = false, searchDate = false) {
    let typeBox = this.state.apiPage;
    let url = configBase.api + 'Sales/dataDashboardFilter?access_token=' + localStorage.getItem('planos_t');
    let filter = {
      userId: localStorage.getItem('planos_u'),
      limit: this.state.itemsPerPage,
      skip: this.state.currentPage * this.state.itemsPerPage
    };

    // Lógica de Pesquisa
    if (this.state.searchTerm) {
      switch (this.state.searchField) {
        case 'namePlan': filter.namePlan = String(this.state.searchTerm); break;
        case 'firstName':
        case 'email':
        case 'salesmanName':
        case 'brokerName': filter[this.state.searchField] = String(this.state.searchTerm); break;
        case 'proposalNumber': filter.proposalNumber = String(this.state.searchTerm); break;
        case 'cpf': filter.cpf = this.state.searchTerm.replace(/\D/g, ''); break;
        default: filter[this.state.searchField] = String(this.state.searchTerm);
      }
    }

    if (typeBox !== null && typeBox !== 'all') {
      filter.content = typeBox;
      // Se tiver filtro de data, adicione aqui a lógica do this.state.date
    }

    // Se for 'all', precisa usar endpoint diferente ou adicionar lógica específica
    if (typeBox === 'all') {
      url = configBase.api + 'FinancialManagers/getProposalAll?access_token=' + localStorage.getItem('planos_t');
      // Mantém a estrutura do filter com paginação e busca
      // Nota: Verifique se o endpoint getProposalAll suporta limit, skip e filtros de busca
    }

    if (typeBox === null) {
      if (!this._isMounted) return;
      this.setState({ data: 'zero', isLoading: false });
      return;
    }

    // Chamada API
    axios.post(url, filter)
      .then((response) => {
        if (!this._isMounted) return;
        
        let allPlans = [];
        let total = 0;

        // O backend sempre retorna plans e count, independente do tipo
        allPlans = response.data.plans || response.data[typeBox + 'Data'] || [];
        total = response.data.count || response.data.total || allPlans.length;

        // Verifica o vendedor padrão
        if (response.data.salesmanDefault && response.data.salesmanDefault === true) {
          this.setState({ showColSalesman: true });
        }

        if (allPlans.length === 0) {
          this.setState({ 
            data: 'zero', 
            totalItems: total,
            isLoading: false,
            isSearching: false,
            isPaginationLoading: false,
            loadingTable: null
          });
        } else {
          this.setColorStatus(allPlans); // Processa as cores
          
          this.setState({
            totalItems: total,
            isLoading: false,
            isSearching: false,
            isPaginationLoading: false,
            loadingTable: null,
            showTable: true
          });
        }
      })
      .catch(() => {
        if (this._isMounted) {
          this.setState({ 
            data: 'error', 
            isLoading: false,
            isSearching: false,
            isPaginationLoading: false
          });
        }
      });
  }

  setColorStatus(proposals) {
    let colors = {
      'PAGAMENTO PENDENTE': {color: configBase.bgPendente, name: configBase.statusPendente},
      'EM VALIDAÇÃO': {color: configBase.bgEmAnalise, name: configBase.statusEmAnalise},
      'PENDENTE': {color: configBase.bgIndeferida, name: configBase.statusIndeferida},
      'CANCELADO': {color: configBase.bgCanceladas, name: configBase.statusCanceladas},
      'EM AVERBAÇÃO': {color: configBase.bgEmAverbacao, name: configBase.statusEmAverbacao},
      'AGUARDANDO CONFIRMAÇÃO': {color: configBase.bgNova, name: configBase.statusNova},
      'ATIVO': {color: configBase.bgImplementadas, name: configBase.statusImplementadas},
      'FUNCIONÁRIO DE EMPRESA': {color: configBase.bgFuncEmpresa, name: configBase.statusFuncEmpresa},
      'PRÉ-IMPLANTADA': {color: configBase.bgPreImplantadas, name: configBase.statusPreImplantadas},
    };
    let state = this.state;

    for (let i = 0; i < proposals.length; i++) {
      proposals[i].color = colors[proposals[i].status].color;
      proposals[i].status = colors[proposals[i].status].name;
    }

    state.data = proposals;
  }

  // Máscara para limpar CPF na busca
  applyCpfMask(value = '') {
    return String(value).replace(/\D/g, '');
  }

  // Debounce para não travar enquanto digita
  handleSearch = (e) => {
    let term = e.target.value || '';
    this.setState({ searchTerm: term, currentPage: 0, isSearching: true });
    
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => { this.getData(true); }, 500);
  }

  handleSearchFieldChange = (e) => {
    this.setState({ searchField: e.target.value, currentPage: 0, isSearching: true }, () => {
      this.getData(true);
    });
  }

  sendDetails(salesId) {
    if (salesId != null) {
      this.props.history.push(`${process.env.PUBLIC_URL}/resumopf?p=${salesId}`);
    }
  }

  sendDetailsFm(financialManagerId) {
    if (financialManagerId != null && financialManagerId !== undefined) {
      this.props.history.push(`${process.env.PUBLIC_URL}/resumosimples?fm=${financialManagerId}`);
    }
  }

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="listaPropostas" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Typography variant="button" gutterBottom>
              {this.state.titlePage}
            </Typography>
          </Paper>

          <div id="listaPropostaConteudo" className="contentepanel">
          {/* ############# CAMPO DE PESQUISA - SEMPRE VISÍVEL ############# */}
          {!this.state.isLoading && (
            <div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} style={{marginBottom: 20, marginTop: 14}}>
                  <Paper elevation={1}>
                    <IconButton style={{padding: '6px 5px'}} aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <select
                      style={{
                        border: 'none',
                        background: 'transparent',
                        marginRight: '2px',
                        padding: '2px',
                        outline: 'none'
                      }}
                      value={this.state.searchField}
                      onChange={this.handleSearchFieldChange}
                    >
                      <option value="firstName">Nome Resp.</option>
                      <option value="cpf">CPF</option>
                      <option value="email">Email</option>
                      {(this.state.isDefaultUser || this.state.showColSalesman) && (
                        <option value="salesmanName">Vendedor</option>
                      )}
                      {(this.state.isDefaultUser || this.state.showColBroker) && (
                        <option value="brokerName">Corretora</option>
                      )}
                      <option value="namePlan">Plano</option>
                      <option value="proposalNumber">Proposta</option>
                    </select>
                    <InputBase
                      id="mySearchText"
                      style={this.styles.inputSearch}
                      placeholder="Pesquisar"
                      value={this.state.searchTerm || ''}
                      onChange={this.handleSearch}
                      inputProps={{ 'aria-label': 'pesquisar propostas' }}
                    />
                  </Paper>
                </Grid>
              </Grid>
              
              {/* Loading durante pesquisa */}
              {this.state.isSearching && (
                <Grid container spacing={0} style={{marginTop: 10}}>
                  <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8}>
                    <LinearProgress />
                    <Typography variant="caption" display="block" style={{textAlign: 'center', marginTop: 5, color: '#757575'}}>
                      Pesquisando...
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
                </Grid>
              )}
            </div>
          )}
          {/* ############# FIM CAMPO DE PESQUISA ############# */}
          {
          this.state.isLoading ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  BUSCANDO PROPOSTAS...
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.data === 'error' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="error">Problema ao buscar lista de propostas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.data === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Sem propostas cadastradas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
            <div id="listaPropostaTabela">

              <style>{`
                #table_id tbody tr {
                  border: none !important;
                  border-bottom: none !important;
                }
                #table_id tbody td {
                  border: none !important;
                  border-bottom: none !important;
                }
                #table_id thead th {
                  border: none !important;
                }
              `}</style>
              <table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%', borderCollapse: 'collapse', borderSpacing: 0}}>
                <thead style={{backgroundColor: configBase.corPrincipal}}>
                  <tr style={this.styles.theadTr}>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Data
                      </Typography>
                    </th>

                    {
                      this.state.showDateActive === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Implantado
                      </Typography>
                    </th>
                      )
                    }

                    {
                      this.state.showDateActive === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Cód. S4E
                      </Typography>
                    </th>
                      )
                    }

                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Proposta
                      </Typography>
                    </th>
                    {
                      this.state.showColBroker === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Corretora
                      </Typography>
                    </th>
                      )
                    }

                    {
                    this.state.showColSalesman === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Vendedor
                      </Typography>
                    </th>
                    )
                    }

                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Resp. Financeiro
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        CPF
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Plano
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Vidas
                      </Typography>
                    </th>
                    {
                      this.state.showColNossoNumero === true && (
                        <>
                          <th style={this.styles.theadTh}>
                            <Typography
                              variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                            >
                              Nosso Número
                            </Typography>
                          </th>
                          <th style={this.styles.theadTh}>
                            <Typography
                              variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                            >
                              NSU
                            </Typography>
                          </th>
                          <th style={this.styles.theadTh}>
                            <Typography
                              variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                            >
                              Cód. Autorização
                            </Typography>
                          </th>
                        </>
                      )
                    }
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Valor
                      </Typography>
                    </th>

                    {
                      this.state.showColStage === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Estágio
                      </Typography>
                    </th>
                      )
                    }

                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Status
                      </Typography>
                    </th>
                  </tr>
                </thead>

                <tbody>
                {this.state.data.map((item, index) =>
                  <tr
                    id={'row_sales_'+item.salesId}
                    key={index}
                    className="row_table"
                    onClick={
                      (item.salesId === null || item.salesId === undefined) ? (
                        this.sendDetailsFm.bind(this, item.financialManagerId)
                      ) : (
                        this.sendDetails.bind(this, item.salesId)
                      )
                    }
                    style={{cursor:'pointer', height: 35, padding: 0, border: 'none', borderBottom: 'none'}}
                  >
                    <td style={{...this.styles.tdDate, border: 'none', borderBottom: 'none'}}>
                      {item.date}
                    </td>

                    {
                      this.state.showDateActive === true && (
                    <td style={{...this.styles.tdDate, border: 'none', borderBottom: 'none'}}>
                      {item.dateActive}
                    </td>
                      )
                    }

                    {
                      this.state.showDateActive === true && (
                    <td style={{padding: 0, height: 35, border: 'none', borderBottom: 'none'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.codeSaveS4Contract}
                      </Typography>
                    </td>
                      )
                    }

                    <td style={{padding: 0, height: 35, border: 'none', borderBottom: 'none'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.proposalNumber}
                      </Typography>
                    </td>

                    {
                      this.state.showColBroker === true && (
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.broker}
                      </Typography>
                    </td>
                      )
                    }

                    {
                      this.state.showColSalesman === true && (
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.salesman}
                      </Typography>
                    </td>
                      )
                    }

                    <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.financialManager}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.cpf}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.plan}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.lives}
                      </Typography>
                    </td>
                    {
                      this.state.showColNossoNumero === true && (
                        <>
                          <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}}>
                            <Typography
                              variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin:0, fontSize: 8.5}}
                            >
                              {item.nossoNumero}
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}}>
                            <Typography
                              variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin:0, fontSize: 8.5}}
                            >
                              {item.nsu}
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}}>
                            <Typography
                              variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin:0, fontSize: 8.5}}
                            >
                              {item.autorizacaoCodigo}
                            </Typography>
                          </td>
                        </>
                      )
                    }
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}} data-order={item.value.replace(',', '')}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {'R$ ' + item.value}
                      </Typography>
                    </td>

                    {
                      this.state.showColStage === true && (
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal', border: 'none', borderBottom: 'none'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.stageForm}
                      </Typography>
                    </td>
                      )
                    }

                    <td style={{padding: 0, height: 35, whiteSpace: 'nowrap', border: 'none', borderBottom: 'none'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, marginRight: 5, fontSize: 8.5}}
                      >
                        <span
                          style={{padding: '5px 7px', border: '1px solid '+item.color, borderRadius: 5, color: item.color}}
                        >
                          {item.status}
                        </span>
                      </Typography>
                    </td>
                  </tr>
                )}
                </tbody>
              </table>

              <div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee', display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                <div style={{position: 'relative', right: 100, fontSize: 12, fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', color: '#707070', display: 'flex', alignItems: 'center'}}>
                  <label htmlFor="itemsPerPage" style={{fontSize: 12, color: '#707070', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', margin: 0, display: 'inline-block'}}>Linhas por página: </label>
                  <select 
                    value={this.state.itemsPerPage}
                    onChange={(e) => {
                      this.setState({
                        itemsPerPage: parseInt(e.target.value),
                        currentPage: 0,
                        isPaginationLoading: true
                      }, () => this.getData(true, false));
                    }}
                    style={{background: 'transparent', border: 'none', marginLeft: 10, color: '#707070', fontSize: 12, fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', cursor: 'pointer', outline: 'none', padding: 0, display: 'inline-block'}}
                  >
                    <option value="10">10</option>
                    <option value="35">35</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span style={{marginLeft: 15, fontSize: 12, color: '#707070', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', display: 'inline-block'}}>
                    {this.state.currentPage * this.state.itemsPerPage + 1}
                  </span>
                  <span style={{marginLeft: 4, marginRight: 4, fontSize: 12, color: '#707070', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', display: 'inline-block'}}>
                    -
                  </span>
                  <span style={{fontSize: 12, color: '#707070', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', display: 'inline-block'}}>
                    {Math.min((this.state.currentPage + 1) * this.state.itemsPerPage, this.state.totalItems)}
                  </span>
                  <span style={{marginLeft: 8, marginRight: 8, fontSize: 12, color: '#707070', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', display: 'inline-block'}}>
                    de
                  </span>
                  <span style={{fontSize: 12, color: '#707070', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', display: 'inline-block'}}>{this.state.totalItems}</span>
                  <button 
                    onClick={() => {
                      if (this.state.currentPage > 0) {
                        this.setState({
                          currentPage: this.state.currentPage - 1,
                          isPaginationLoading: true
                        }, () => this.getData(true, false));
                      }
                    }}
                    disabled={this.state.currentPage === 0}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: this.state.currentPage === 0 ? 'default' : 'pointer',
                      opacity: this.state.currentPage === 0 ? 0.5 : 1,
                      padding: 0,
                      marginLeft: 10,
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{fontSize: 16}}>
                      <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path>
                    </svg>
                  </button>
                  <button 
                    onClick={() => {
                      if ((this.state.currentPage + 1) * this.state.itemsPerPage < this.state.totalItems) {
                        this.setState({
                          currentPage: this.state.currentPage + 1,
                          isPaginationLoading: true
                        }, () => this.getData(true, false));
                      }
                    }}
                    disabled={(this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: (this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems ? 'default' : 'pointer',
                      opacity: (this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems ? 0.5 : 1,
                      padding: 0,
                      marginLeft: 10,
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{fontSize: 16}}>
                      <path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path>
                    </svg>
                  </button>
                </div>
              </div>

            </div>
              )
              )
            )
          }
          </div>
        </div>
      </MainLayout>
    );

  }

}

ListaPropostas.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostas);
 